module.exports = __webpack_public_path__ + "img/6d75a4e.png";